import React, { memo } from 'react';
import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import RadioStars from '../../../../directives/Radio/RadioStars/RadioStars';
import RadioWorm from '../../../../directives/Radio/RadioWorm/RadioWorm';
import * as Styled from './Style';
/**
 *  Группа вопросов
 *  обратной связи по заказу
 */
const GroupQuestions = ({
  header,
  title,
  description,
  top,
  left,
  bottom,
  right,
  radioChangeHandler,
  textareaChangeHandler,
  checkboxChangeHandler,
  errorsIds
}) => {
  const isTop = !!top.length;
  const isRight = !!right.length;
  const isBottom = !!bottom.length && !!bottom[0].answers.length;
  const isLeft = !!left.length;
  const errors = new Set(errorsIds);
  const isTopHasErrors = top.some(({
    id
  }) => errors.has(id));
  const isRightHasErrors = right.some(({
    id
  }) => errors.has(id));
  return /*#__PURE__*/React.createElement(Styled.Carrier, null, header, /*#__PURE__*/React.createElement(Styled.Content, null, /*#__PURE__*/React.createElement(Styled.Title, null, title), description && /*#__PURE__*/React.createElement(Styled.Description, null, description), isTop && /*#__PURE__*/React.createElement(Styled.Row, null, /*#__PURE__*/React.createElement(Styled.Column, null, top.map(question => /*#__PURE__*/React.createElement("div", {
    id: question.id,
    key: question.id
  }, /*#__PURE__*/React.createElement(Styled.ScaleUpper, null, /*#__PURE__*/React.createElement("div", null, I18n.t('components.GroupQuestions.top_no')), /*#__PURE__*/React.createElement("div", null, I18n.t('components.GroupQuestions.top_yes'))), /*#__PURE__*/React.createElement(RadioWorm, {
    ...question,
    changeHandler: radioChangeHandler(question)
  }))), isTopHasErrors && /*#__PURE__*/React.createElement(Styled.TextPrimary, null, I18n.t('pages.account.feedback_poll.validator.nps')))), (isLeft || isRight) && /*#__PURE__*/React.createElement(Styled.Row, null, isLeft && /*#__PURE__*/React.createElement(Styled.Column, null, left.map(question => /*#__PURE__*/React.createElement("div", {
    key: question.id,
    className: "form-group"
  }, /*#__PURE__*/React.createElement(Styled.Textarea, {
    className: "form-control",
    placeholder: question.title,
    rows: 7,
    onChange: textareaChangeHandler(question)
  })))), isRight && /*#__PURE__*/React.createElement(Styled.Column, null, /*#__PURE__*/React.createElement(Styled.Rating, null, right.map(question => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioStars, {
    key: question.id,
    ...question,
    changeHandler: radioChangeHandler(question)
  }))), isRightHasErrors && /*#__PURE__*/React.createElement(Styled.TextPrimary, null, I18n.t('pages.account.feedback_poll.validator.rating'))))), isBottom && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Styled.Title, null, I18n.t('components.GroupQuestions.bottom_title')), /*#__PURE__*/React.createElement(Styled.Description, null, I18n.t('components.GroupQuestions.bottom_description')), /*#__PURE__*/React.createElement(Styled.Row, null, /*#__PURE__*/React.createElement(Styled.ColumnCount, null, bottom.map(question => question.answers.map(answer => /*#__PURE__*/React.createElement(Styled.CheckboxContainer, {
    key: answer.id
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox checkbox-primary verify-panel__checkbox"
  }, /*#__PURE__*/React.createElement("input", {
    id: `checkbox${answer.id}`,
    type: "checkbox",
    onChange: checkboxChangeHandler(question, answer),
    defaultChecked: answer.value
  }), /*#__PURE__*/React.createElement(Styled.CheckboxLabel, {
    htmlFor: `checkbox${answer.id}`
  }, /*#__PURE__*/React.createElement("i", {
    className: "verify-panel__checkbox-icon"
  }), /*#__PURE__*/React.createElement("span", null, answer.title)))))))))));
};
GroupQuestions.propTypes = {
  /** Шапка руппы */header: PropTypes.node,
  /** Заголовок */title: PropTypes.string.isRequired,
  /** Описание */description: PropTypes.string,
  top: PropTypes.array,
  left: PropTypes.array,
  bottom: PropTypes.array,
  right: PropTypes.array,
  errorsIds: PropTypes.array,
  /** Изменение радио кнопок */radioChangeHandler: PropTypes.func,
  /** Изменение текстового поля */textareaChangeHandler: PropTypes.func,
  /** Изменение чекбокса */checkboxChangeHandler: PropTypes.func
};
export default hot(/*#__PURE__*/memo(GroupQuestions));